<template>
    <!-- 排课 -->
    <el-dialog custom-class="dialogForm" class="measDialog scheduleDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title">
        <el-scrollbar class="dialogContentScroll">
            <div class="scheduleConte">
                <div class="modelBox flex">
                    <span @click="changeModel('gzModel')" :class="activeName === 'gzModel'?'activeModel':''" class="gzModel">规则排课</span>
                    <span @click="changeModel('dateMode')" :class="activeName === 'dateMode'?'activeModel':''" class="dateMode">日历排课</span>
                </div>
                <div class="formContent">
                    <!-- 规则 -->
                    <RuleClass v-if="activeName === 'gzModel'" :classCode="classCode" :className="className" :classCourseCode="classCourseCode" :classCourseName="classCourseName" @handleClose1="handleClose1" ref="gzModel"/>
                    <!-- 日历 -->
                    <Calendar v-if="activeName === 'dateMode'" :classCode="classCode" :className="className" :classCourseCode="classCourseCode" :classCourseName="classCourseName" @handleClose1="handleClose1" ref="dateMode" />
                </div>
            </div>
        </el-scrollbar>
        <span slot="footer" class="dialog-footer">
            <el-button  @click="visible = false">取消</el-button>
            <el-button  type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import RuleClass from './schedule/ruleClass.vue'
import Calendar from './schedule/calendar.vue'
export default {
    
    data(){
        return {
            visible: false,
            title: '排课',
            activeName: 'gzModel',
            classCode: '',
            className: '',
            classCourseCode: '',
            classCourseName: ''
        }
    },
    components: {
        RuleClass,
        Calendar
    },
    methods: {
        init(classCode, className,classCourseCode,classCourseName){
            if(classCode){
                this.classCode = classCode
                this.className = className
            }
            if(classCourseCode){
                this.classCourseCode = classCourseCode
                this.classCourseName = classCourseName
            }
           this.visible = true
           this.activeName = 'gzModel'
           this.$nextTick(() => {
                this.$refs.gzModel.init()
           })
        },
        handleClose(){
            this.visible = false 
            this.activeName = 'gzModel'
        },
        handleClose1(){
            this.visible = false 
        },
        changeModel(activeName){
            this.activeName = activeName
            this.$nextTick(() => {
                if(activeName === 'gzModel'){
                    this.$refs.gzModel.init()
                }else{
                    this.$refs.dateMode.init()
                }
            })
        },
        submit(){
            if(this.activeName === 'gzModel'){
                this.$refs.gzModel.submit('form')
            }else{
                this.$refs.dateMode.submit('form')
            }
        },
    }
        
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body{
    padding: 0!important;
}
.scheduleConte{
    .weekContent{
        align-items: center;
        // border-right: 1px solid #EAEAEA;
        .item{
            text-align: center;
            font-size: 14px;
            color: #666666;
            height: 32px;
            width: 68px;
            border: 1px solid #EAEAEA;
            cursor: pointer;
        }
        .activeItem{
            border: 1px solid #409EFF;
            color: #409EFF;
        }
    }
    >.el-scrollbar__wrap{
        padding: 0!important;
    }
    .modelBox{
        background: #F6F7FB;
        height: 44px;
        color: #666666;
        font-size: 14px;
        line-height: 44px;
        .gzModel,.dateMode{
            padding: 0 20px;
            cursor: pointer;
        }
        .activeModel{
            background: white;
        }
    }
    .formContent{
        padding: 20px;
    }
}
</style>